import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

// ✅ Custom styles (reusable)
const customStyles = {
  control: (base, state) => ({
    ...base,
    border: "1px solid #0d6efd",
    borderRadius: "6px",
    padding: "4px 8px",
    minHeight: "38px",
    height: "38px",
    boxShadow: state.isFocused
      ? "0 0 4px rgba(13,110,253,0.5)"
      : "0 3px 2px rgba(13,110,253,0.15)",
    backgroundColor: state.isFocused ? "#e7f1ff" : "#f8f9fa",
    fontSize: "1rem",
    fontWeight: "400",
    transition: "all 0.2s ease",
    cursor: "pointer",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "0.95rem",
    fontWeight: state.isSelected ? "500" : "400",
    backgroundColor: state.isSelected
      ? "#0d6efd"
      : state.isFocused
      ? "#e7f1ff"
      : "white",
    color: state.isSelected ? "white" : "#333",
    padding: "6px 8px",
    cursor: "pointer",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
    fontSize: "0.95rem",
    fontWeight: "500",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#0d6efd",
    fontWeight: "600",
    fontSize: "1rem",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 6px",
  }),
};

const SurveySelect = ({ value, onChange, notify }) => {
  const [loading, setLoading] = useState(false);
  const [surveys, setSurveys] = useState([]);

  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000/api/pos";

  const authHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const fetchSurveys = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/feedback/surveys`, authHeaders());
      const data = Array.isArray(res.data) ? res.data : [];

      const normalized = data.map((s) => ({
        id: s.surveyid || s.id,
        surveyid: s.surveyid || s.id,
        title: s.title,
        key:
          (s.sharing && s.sharing.key) ||
          s.key ||
          `survey-${s.surveyid || s.id}`,
        createdAt: s.created_at
          ? new Date(s.created_at).toISOString().split("T")[0]
          : s.createdAt,
        status: s.status || "Draft",
        responses: s._response_count || s.responses || 0,
        questions: s.questions || [],
        branding: s.branding || {},
        settings: s.settings || {},
      }));

      // ✅ Only keep Active surveys
      const activeSurveys = normalized.filter(
        (s) => (s.status || "").toLowerCase() === "active"
      );

      setSurveys(activeSurveys);
    } catch (err) {
      console.error("Error fetching surveys:", err);
      if (notify) notify("error", "Failed to load surveys.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSurveys();
  }, []);

  const surveyOptions = surveys.map((s) => ({
    value: s.surveyid,
    label: `📋 ${s.title || "Untitled Survey"}`,
  }));

  return (
    <div style={{ minWidth: "300px" }}>
      <Select
        value={surveyOptions.find((opt) => opt.value === value)}
        onChange={onChange}
        options={surveyOptions}
        placeholder={loading ? "Loading surveys..." : "🔍 Select Active Survey"}
        isLoading={loading}
        isClearable
        styles={customStyles}
      />
    </div>
  );
};

export default SurveySelect;
